import { useState } from "react";

import { capitalize } from "lodash";
import { DefaultPopover, Separator, Button, DefaultTooltip } from "twyne-new.ui";

import { useAvailableProps } from "@/modules/cms/views/post/components/builder/context";

import { ListContainer, SearchInput } from "../../properties/components/tailwindSandbox";
import { useCustomProp } from "../hooks";

import { useToolbar } from "./context";

export default function Add({ trigger, hideProps, showOnAddProps }) {
  const { value: blockProps = [], setValue: setBlockProps } = useCustomProp('sidebarProps')
  const { value: suppressSidebarProps = [], setValue: setSuppressSidebarProps } = useCustomProp('suppressSidebarProps')
  const availableProps = useAvailableProps(showOnAddProps)

  const [search, setSearch] = useState('')
  const [propsDisplayed, setPropsDisplayed] = useState(availableProps)

  const [open, setOpen] = useState(false)

  const { useChangeOpenPopover } = useToolbar()
  useChangeOpenPopover({ open, value: 'addProps' })

  const handleClickProp = name => {
    if (suppressSidebarProps.includes(name)) {
      setSuppressSidebarProps(suppressSidebarProps.filter(item => item !== name))
      return
    }

    if (blockProps.includes(name)) {
      setSuppressSidebarProps([...suppressSidebarProps, name])
      return
    }

    setBlockProps([...blockProps, name])
  }

  const handleChangeSearch = value => {
    setSearch(value)
    setPropsDisplayed(searchUtilities(availableProps, value))
  }

  const handleClickCategory = (items, checked) => {
    items = items.filter(item => !item.hasValue).map(item => item.name)
    if (!checked) {
      const newItems = items.filter(item => !blockProps.includes(item))
      setSuppressSidebarProps(suppressSidebarProps.filter(item => !items.includes(item)))
      setBlockProps([...blockProps, ...newItems])
      return
    }

    const newItems = items.filter(item => !suppressSidebarProps.includes(item))
    setSuppressSidebarProps([...suppressSidebarProps, ...newItems])
  }

  const categoryIsToggled = category => {
    const available = propsDisplayed[category].map(item => item.name)
    const toggled = available.filter(item => !blockProps.includes(item) || suppressSidebarProps.includes(item))
    return !toggled.length
  }

  return <>
    <DefaultPopover
      trigger={trigger}
      triggerProps={{ asChild: true }}
      contentProps={{ className: 'w-[600px]', side: 'left', align: 'center' }}
      wrapperProps={{ open, onOpenChange: setOpen }}
    >
      <SearchInput title='Properties' value={search} onChange={handleChangeSearch} onClose={() => setOpen(false)} />
      <Separator className='m-0 my-2' />

      {!Object.values(propsDisplayed).length && <div className='flex w-full justify-center twy-text-base'>No properties found</div>}

      <div className="flex flex-col gap-2 max-h-[80vh] overflow-y-auto">
        {Object.entries(propsDisplayed).map(([category, items]) => {
          const isToggled = categoryIsToggled(category)
          items = items.map(item => ({ ...item, hasValue: document.querySelector(`.has-value-${item.name?.replaceAll('.', '-')}`) }))

          return <div key={category}>
            <ListContainer className='p-1 '>

              <div className="flex gap-2 items-center">
                <span className='twy-text-base-accent text-[12px]'>
                  {category}
                </span>
                <ToggleCategoryButton items={items} isToggled={isToggled} onClickCategory={handleClickCategory} />
              </div>

              <div className="flex gap-2 flex-wrap mb-2 mt-2">
                {items.map(({ label, name, dropdownLabel, hasValue }) => {
                  const variant = hasValue ? 'default' : 'outline'
                  const active = blockProps.includes(name) && !suppressSidebarProps.includes(name)

                  return <>
                    <DefaultTooltip content={hasValue && `You can't deselect because it has value.`}>
                      <Button
                        className={`${!active ? 'outline-none!' : ''}`}
                        key={name}
                        active={active}
                        onClick={() => !hasValue && handleClickProp(name)}
                        disabled={hideProps.includes(name)}
                        variant={variant}
                        color='accent'
                        size='sm'
                      >
                        {dropdownLabel || label || capitalize(name.replace('.', ' '))}
                      </Button>
                    </DefaultTooltip>
                  </>
                })}
              </div>
            </ListContainer>
          </div>
        })}
      </div>
    </DefaultPopover>
  </>
}

const ToggleCategoryButton = ({ items, isToggled, onClickCategory }) => <>
  <span className='text-gray-400 dark:text-gray-500 text-sm hover:underline hover:text-blue-500 dark:hover:text-blue-300 cursor-pointer' onClick={() => onClickCategory(items, isToggled)}>
    {isToggled ? 'Unselect all' : 'Select all'}
  </span>
</>

function searchUtilities(data, searchTerm) {
  if (!searchTerm) return data

  const searchMethod = value => value?.toLowerCase().includes(searchTerm.toLowerCase())
  const result = {}
  Object.entries(data).forEach(([category, items]) => {
    const filtered = items.filter(item => searchMethod(item.label) || searchMethod(item.name) || searchMethod(item.category))

    if (filtered.length > 0) {
      result[category] = filtered
    }
  })

  return result
}
